var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCatalogEntryIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15.41,
    height: 17.76,
    viewBox: "0 0 15.41 17.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30510",
    "data-name": "Group 30510",
    transform: "translate(-0.028 -0.028)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_650",
    "data-name": "Group 650",
    transform: "translate(0.528 0.528)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_11788",
    "data-name": "Path 11788",
    d: "M15.69,6.7h.873A1.764,1.764,0,0,1,18.327,8.46v9.627a1.764,1.764,0,0,1-1.764,1.765h-5.5A1.765,1.765,0,0,1,9.3,18.087",
    transform: "translate(-6.662 -4.912)",
    fill: "none",
    stroke: "#fc8a06",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11789",
    "data-name": "Path 11789",
    d: "M24.06,12.248h.873A1.764,1.764,0,0,1,26.7,14.012v9.626A1.765,1.765,0,0,1,24.933,25.4h-5.5a1.765,1.765,0,0,1-1.764-1.765",
    transform: "translate(-12.288 -8.644)",
    fill: "none",
    stroke: "#fc8a06",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_11790",
    "data-name": "Path 11790",
    d: "M8.518,14.41h-5.5a1.765,1.765,0,0,1-1.764-1.764V3.019A1.765,1.765,0,0,1,3.018,1.254h5.5a1.764,1.764,0,0,1,1.764,1.765v9.627A1.764,1.764,0,0,1,8.518,14.41Z",
    transform: "translate(-1.254 -1.254)",
    fill: "none",
    stroke: "#fc8a06",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_44",
    "data-name": "Line 44",
    x2: 4.997,
    transform: "translate(2.092 4.021)",
    fill: "none",
    stroke: "#fc8a06",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_45",
    "data-name": "Line 45",
    x2: 3.376,
    transform: "translate(2.092 6.233)",
    fill: "none",
    stroke: "#fc8a06",
    strokeLinecap: "round",
    strokeWidth: 1
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_46",
    "data-name": "Line 46",
    x2: 1.891,
    transform: "translate(2.092 8.444)",
    fill: "none",
    stroke: "#fc8a06",
    strokeLinecap: "round",
    strokeWidth: 1
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCatalogEntryIcon);
export default __webpack_public_path__ + "static/media/catalog_entryIcon.fc92930a9ad3ab3e55039ed6a1f016c7.svg";
export { ForwardRef as ReactComponent };